import { CompanyPaths } from "Company/Routes/Routing";
import {
	type CompanyUpdateDto,
	patchCompaniesId,
} from "Infrastructure/Api/Api";
import { processResponse } from "Infrastructure/Api/ApiUtils";
import { Resources, useResource } from "Infrastructure/Translation/Resources";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useNavigate } from "react-router";
import { toast } from "sonner";
import { COMPANY_LIST } from "../Query/useCompanyListQuery";

const companyMutationsResource = Resources.base.company.mutations;

export const useUpdateCompany = (companyId: number) => {
	const { t } = useResource();
	const queryClient = useQueryClient();
	const navigate = useNavigate();

	return useMutation({
		mutationFn: processResponse((data: Partial<CompanyUpdateDto>) =>
			patchCompaniesId(data, companyId),
		),
		onError: (error) => {
			console.error(
				`${t(companyMutationsResource.companyUpdateError)}:`,
				error,
			);
		},
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: [COMPANY_LIST] });
			navigate(CompanyPaths.Index.path);
			toast.success(t(companyMutationsResource.companyUpdateSuccess));
		},
	});
};
